import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createBillingReconciliationRun,
  deleteBillingReconciliationRun,
  importBillingReconciliationHistoricalBackfill,
  previewBillingReconciliationHistoricalBackfill,
} from './billingReconciliationApi.js';
import { updateBillingReconciliationHistoryAdjustment } from './billingReconciliationHistoryApi.js';

export const useCreateBillingReconciliationRun = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBillingReconciliationRun,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'runs'] });
    },
  });
};

export const usePreviewBillingReconciliationHistoricalBackfill = () => useMutation({
  mutationFn: previewBillingReconciliationHistoricalBackfill,
});

export const useImportBillingReconciliationHistoricalBackfill = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importBillingReconciliationHistoricalBackfill,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'runs'] });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'history'] });
    },
  });
};

export const useUpdateBillingReconciliationHistoryAdjustment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationHistoryAdjustment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'history'] });
    },
  });
};

export const useDeleteBillingReconciliationRun = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBillingReconciliationRun,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'runs'] });
    },
  });
};
